import { makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
  heading: {
    color: theme.palette.text.main,
  },
}));
function DefaultHeading({ text }) {
  const classes = useStyles();
  return <h3 className={classes.heading}>{text}</h3>;
}

export default DefaultHeading;
